import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Footer.scss';

const Footer = () => (
  <footer className="sub-text txt-al-c ttn-3">
    <p>Made with <FontAwesomeIcon icon="heart" aria-label="love"/> <span className="sr-only">love</span> by <a href="https://clintonpi.github.io/" target="_blank" rel="noopener noreferrer" className="text-link">Clinton Nkwocha</a>.</p>
  </footer>
);

export default Footer;
